module.exports = __webpack_public_path__ + "img/Green-Earth-Final.a2b1fca4.png";